import { GeckoColorScale } from 'color-scale-kit'
import ExcelJS from 'exceljs'
import { GeckoBinnedDataBuffer } from 'features/dataLayers/geckoBinnedDataBuffer'
import {
  GeckoComponentDataFrame,
  GeckoComponentModel,
  GeckoInspection,
  GeckoMeasurementUnit,
  GeckoView,
} from 'types'

import { appendExcelDataSheets, createSummarySheet } from './ExcelUtils'

export interface CombinedExcelDataLayer {
  binnedDataBuffer: GeckoBinnedDataBuffer
  cdf: GeckoComponentDataFrame
  colorScale?: GeckoColorScale
  title: string
}

interface CreateCombinedExcelWorkbookParams {
  componentName: string
  dataLayers: ReadonlyArray<CombinedExcelDataLayer>
  getPreferredMeasurementUnit: (
    inputUnit: GeckoMeasurementUnit
  ) => GeckoMeasurementUnit
  inspection: GeckoInspection
  organizationName: string
  selectedComponentModel: GeckoComponentModel | undefined
  siteName: string
  unitName: string
}

export const createCombinedExcelWorkbook = ({
  componentName,
  dataLayers,
  getPreferredMeasurementUnit,
  inspection,
  organizationName,
  selectedComponentModel,
  siteName,
  unitName,
}: CreateCombinedExcelWorkbookParams) => {
  const workbook = new ExcelJS.Workbook()
  const thicknessLayer = dataLayers.find(
    ({ cdf }) => cdf.data.params.view.id === GeckoView.Thickness.id
  )
  const referenceCdf = thicknessLayer?.cdf ?? dataLayers[0]?.cdf

  if (!referenceCdf) return workbook

  createSummarySheet(
    workbook,
    organizationName,
    siteName,
    unitName,
    inspection.data.date?.toISOString().split('T')[0] ?? 'N/A',
    'EMAT',
    getPreferredMeasurementUnit(referenceCdf.data.params.measurement_unit).name,
    getPreferredMeasurementUnit(referenceCdf.data.geometry.x.unit).name,
    getPreferredMeasurementUnit(referenceCdf.data.geometry.y.unit).name
  )

  dataLayers.forEach(({ binnedDataBuffer, cdf, colorScale, title }) => {
    appendExcelDataSheets({
      binnedDataBuffer,
      colorScale,
      componentName,
      getPreferredMeasurementUnit,
      selectedCDF: cdf,
      selectedComponentModel,
      titlePrefix: title,
      workbook,
    })
  })

  return workbook
}
